<template>
  <w-sliding-popup ref="eventTimelinePopup" :type="popupType" :title="title" width="600px" @close="onClose">
    <div slot="content" >
      <w-timeline-work-info v-if="currentView == 'WORK'" :selectedEvent="selectedEvent" ref="workInfo"></w-timeline-work-info>
      <w-timeline-config-info v-else-if="currentView == 'CONFIG_CHANGE'" :selectedEvent="selectedEvent" ref="config_changeInfo"></w-timeline-config-info>
      <w-timeline-trouble-ticket-info v-else :selectedEvent="selectedEvent" ref="trouble_ticketInfo"></w-timeline-trouble-ticket-info>
    </div>
  </w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import WTimelineWorkInfo from '@/views/performance/root/components/popup/components/TimelineWorkInfo';
import WTimelineTroubleTicketInfo from '@/views/performance/root/components/popup/components/TimelineTroubleTicketInfo';
import WTimelineConfigInfo from '@/views/performance/root/components/popup/components/TimelineConfigInfo';

export default {
  name: 'WEventTimelinePopup',
  watch: {
    selectedEvent: {
      deep: true,
      immediate: true,
      handler() {
        if (!isNil(this.selectedEvent)) {
          this.currentView = this.selectedEvent.timelineType;
        }
      },
    },
    visible: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  data() {
    return {
      currentView: null,
      popupType: 'common', // default
    };
  },
  computed: {
    title() {
      if (!isNil(this.selectedEvent)) {
        return `${this.selectedEvent.timelineTarget} ${this.selectedEvent.timelineTypeName}`;
      }
      return '';
    },
    showSettingView() {
      return this.$store.state.common.showSettingView;
    },
    visible() {
      return this.$store.state.popup.showEventTimelinePopup;
    },
    selectedEvent() {
      return this.$store.state.popup.eventTimelinePopupParams;
    },
  },
  components: {
    WTimelineWorkInfo,
    WTimelineTroubleTicketInfo,
    WTimelineConfigInfo,
  },
  beforeDestroy() {
    if (this.visible) {
      this.close();
    }
  },
  methods: {
    open() {
      this.$refs.eventTimelinePopup.open();
      this.popupType = this.showSettingView ? 'setting' : 'common';
      this.$nextTick(() => {
        this.$refs[`${this.selectedEvent.timelineType.toLowerCase()}Info`].loadData();
      });
    },
    close() {
      this.$refs.eventTimelinePopup.close();
    },
    onClose() {
      if (this.selectedEvent.timelineType === 'CONFIG_CHANGE') {
        this.$refs[`${this.selectedEvent.timelineType.toLowerCase()}Info`].resetFilter();
      }
      this.$store.dispatch('closeEventTimelinePopup');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/popup/EventTimelinePopup/index.vue